export const environments = {
  VERCEL_ENV: process.env.VERCEL_ENV,
  BASE_URL_PROD: process.env.NEXT_PUBLIC_BASE_URL_PROD!,
  BASE_URL_DEV: process.env.NEXT_PUBLIC_BASE_URL_DEV!,
  SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL!,
  SUPABASE_PUBLISHABLE_KEY: process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!,
  EMAILJS_KEY: process.env.NEXT_PUBLIC_EMAILJS_KEY!,
  EMAILJS_TEMPLATE_ID: process.env.NEXT_PUBLIC_EMAILJS_TEMPLATE_ID!,
  EMAILJS_SERVICE_ID: process.env.NEXT_PUBLIC_EMAILJS_SERVICE_ID!,
  RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!,
  SUPABASE_SECRET_KEY: process.env.SUPABASE_SECRET_KEY!,
  GOOGLE_SITE_VERIFICATION: process.env.GOOGLE_SITE_VERIFICATION!,
  GOOGLE_GENERATIVE_AI: process.env.GOOGLE_GENERATIVE_AI_API_KEY!,
  GOOGLE_GENERATIVE_AI_MODEL: process.env.GOOGLE_GENERATIVE_AI_MODEL!,
  DEEPL_AUTH_KEY: process.env.DEEPL_AUTH_KEY!,
  OWNER_EMAIL: process.env.OWNER_EMAIL!,
  GUEST_EMAIL: process.env.NEXT_PUBLIC_GUEST_EMAIL!,
  GUEST_PASSWORD: process.env.GUEST_PASSWORD!,
  OWNER_ID: process.env.OWNER_ID!,
};
